<template>
    <div v-if="modalAlert" class="toggle-alert">
        <div class=" -container">
            <div class="modal-content">
                <div class="">
                    <div id="alert-modal" class="card bg-orange-gradLight">
                        <button class="btn-close" @click="modalAlertHandler">
                            <img :src="close" alt="close">
                        </button>
                        <div class="card-body">
                            <div class="mensages-container">
                                <img :src="warning" alt="warning" class="message-img">

                                <h1>{{ title }}</h1>

                                <div class="modal-bottom double">
                                    <div class="text-center">
                                        <button class="btn-bg" @click="modalAlertHandler">{{ button }}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import icClose from '../../svg/ic_close_orange.svg'
import icWarning from '../../svg/ic_warning.svg'
import { EventBus } from '../event-bus';

export default {
    props: {
        title:String,
        button: {
            type: String,
            default: 'Ok, entendi'
        },
        showModal: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            close: icClose,
            warning: icWarning,
            modalAlert: false
        }
    },
    methods: {
        modalAlertHandler() {
            this.modalAlert = !this.modalAlert;

            document.querySelector('html').classList.toggle('no-scroll');
            document.querySelector('body').classList.toggle('no-scroll');
        },
    },
    mounted() {
        EventBus.$on('display-error', (payload) => {
            this.title = payload.message;
            this.modalAlertHandler();
        });

        if (this.showModal) {
            this.modalAlertHandler();
        }
    },
}
</script>
